import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  ChangeDetectorRef,
  NgZone,
} from "@angular/core";
import moment from "moment";

import { MatDialog } from "@angular/material/dialog";
import {
  EventInput,
  Calendar,
  CalendarOptions,
  EventApi,
} from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { FullCalendarComponent, FullCalendarModule } from "@fullcalendar/angular";
import frLocale from "@fullcalendar/core/locales/fr";
import momentPlugin from "@fullcalendar/moment";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import { SlotType } from "src/app/enums/SlotType.enum";
import { BookingSlotType } from "src/app/models/booking-slot-type";
import { BookingSlotsService } from "src/app/services/booking-slots.service";
import { BookingSlot } from "src/app/models/booking-slot";
import { DoctorService } from "src/app/services/doctor.service";
import { Doctor } from "src/app/models/doctor";
import { BOOKING_DIALOG_CONFIG, BookingDialogComponent } from "src/app/components/booking-dialog/booking-dialog.component";
import { SnackBarService } from "src/app/services/snack-bar.service";
import { ErrorsHandler } from "src/app/services/error-handler.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";

import { BookingHelper } from "src/app/helpers/booking_helper";
import { StateType } from "src/app/enums/stateType.enum";
import { BookingType } from "src/app/enums/bookingType.enum";
import { GlobalService } from "src/app/services/global.service";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import { of, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as Sentry from "@sentry/angular";
import { Router } from "@angular/router";
import { ClinicResourceAvailability } from "src/app/models/clinic_resource_availability";
import { CalendarRefreshService } from '../../services/calendar-refresh.service';
import { ErrorHelper } from "src/app/helpers/error_helper";
import { AlertService } from "src/app/services/alert.service";
import { SelectOption } from "src/app/shared/components/custom-select/custom-select.component";
import { DoctorResourceService } from "src/app/services/doctor-resources.service";
import { DoctorResource } from "src/app/models/doctor_resource";
import { DatePickerModule } from "primeng/datepicker";
import { PrimeNG } from "primeng/config";
import { FormsModule } from "@angular/forms";
import { getPrimeNgDateLocale } from "src/app/helpers/primeng-date-locale";
import { AppointmentCardComponent } from "../appointment-card/appointment-card.component";
import { AppointmentCategoriesCardComponent } from "../appointment-categories-card/appointment-categories-card.component";
import { CustomSelectComponent } from "../../shared/components/custom-select/custom-select.component";
import { CustomButtonComponent } from "../../shared/components/custom-button/custom-button.component";
import { LoadingBadgeComponent } from "../../shared/components/loading-badge/loading-badge.component";

@Component({
  standalone: true,
    templateUrl: "./calendar.component.html",
    styleUrls: ["./calendar.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [DatePickerModule, FormsModule, AppointmentCardComponent, AppointmentCategoriesCardComponent, CustomSelectComponent, CustomButtonComponent, LoadingBadgeComponent, FullCalendarModule, TranslatePipe]
})
export class CalendarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  selectedDate = new Date();
  year: any;
  DayAndDate: string;
  appointmentTypes = SlotType;
  bookingTypes = BookingType;
  clinic: boolean;
  @ViewChild("calendar", { static: false }) fullcalendar: FullCalendarComponent;
  clinic_resources: any = [];
  fullCalendarApi: Calendar;
  calendarConfig: CalendarOptions;
  toConfirmBookingSlots: BookingSlot[] = [];
  private calendarInitialized = false;
  // A refresh requested before the calendar view is mounted is replayed once
  // FullCalendar is ready (viewDidMount), so early realtime events aren't lost.
  private pendingRefetch = false;

  doctorBookingTypes: BookingSlotType[] = [];
  minDate: Date | null = null;
  maxDate: Date | null = null;
  // Disable weekends (Sunday = 0, Saturday = 6) in the sidebar date picker.
  disabledDays: number[] = [0, 6];
  available_days_for_clinic_resources: ClinicResourceAvailability[];

  isPortletCollapse: boolean = false;
  arrowDirection: boolean = true;
  currentDoctor: Doctor;
  timeIntervals = [
    { value: "15", viewValue: "15m" },
    { value: "20", viewValue: "20m" },
    { value: "30", viewValue: "30m" },
    { value: "60", viewValue: "60m" },
  ];

  totalCountToConfirm = 0;
  currentPageToConfirm = 1;
  totalPagesToConfirm = 1;
  loadingPageToConfirm: boolean = false;
  calendarLoading: boolean = false;

  // Options for custom select components
  get timeIntervalOptions(): SelectOption[] {
    return this.timeIntervals.map(interval => ({
      value: interval.value,
      label: interval.viewValue
    }));
  }

  get startTimeOptions(): SelectOption[] {
    return this.startTimeHours.map(hour => ({
      value: hour.toString(),
      label: hour.toString()
    }));
  }

  get endTimeOptions(): SelectOption[] {
    const options = this.endTimeHours.map(hour => ({
      value: hour.toString(),
      label: hour.toString()
    }));
    options.push({ value: "24", label: "00" });
    return options;
  }

  slotMinTime: number;
  slotMaxTime: number;
  startTimeHours = [5, 6, 7, 8, 9, 10];
  endTimeHours = [17, 18, 19, 20, 21, 22, 23];

  // Add getter and setter for minTime and maxTime to match HTML template bindings
  get minTime(): number {
    return this.slotMinTime;
  }

  set minTime(value: number) {
    this.slotMinTime = value;
  }

  get maxTime(): number {
    return this.slotMaxTime;
  }

  set maxTime(value: number) {
    this.slotMaxTime = value;
  }


  // We use {{isMobile}} and {{initialView}} it to check if the user is no mobile or not: Default (False)
  isMobile: boolean = false;
  initialView: string;
  PressDelay: number = 0;

  togglePortlet(key) {
    if (key == "down") {
      this.arrowDirection = true;
    } else {
      this.arrowDirection = false;
    }
    this.isPortletCollapse = !this.isPortletCollapse;
  }

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private bookingSlotsService: BookingSlotsService,
    private snackbar: SnackBarService,
    private translate: TranslateService,
    private bookingHelper: BookingHelper,
    private errorHandler: ErrorsHandler,
    private primeng: PrimeNG,
    private globalService: GlobalService,
    private doctorService: DoctorService,
    private calendarRefreshService: CalendarRefreshService,
    private errorHelper: ErrorHelper,
    private alertService: AlertService,
    private doctorResourceService: DoctorResourceService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {
    //Check the device if Mobile then show the calendar by day, otherwise show it by week.
    this.checkDevice();
  }

  ngOnInit(): void {
    this.globalService.showSpinner();
    this.doctorService.currentDoctor$.pipe(takeUntil(this.destroy$)).subscribe((currentDoctor) => {

      if (currentDoctor) {
        const isInitialLoad = !this.currentDoctor;
        this.currentDoctor = currentDoctor;
        this.available_days_for_clinic_resources = this.currentDoctor.available_days_for_clinic_resources

        // Update time values when doctor data changes
        if (currentDoctor.opening_hour !== undefined) {
          this.slotMinTime = currentDoctor.opening_hour;
        }
        if (currentDoctor.closing_hour !== undefined) {
          this.slotMaxTime = currentDoctor.closing_hour;
        }

        this.cdr.detectChanges();

        // Only setup calendar on initial load, not on every currentDoctor update
        if (isInitialLoad) {
          // Load resources based on account_type
          if(this.currentDoctor.clinic) {
            if(this.currentDoctor.account_type === 'resource_based' && this.currentDoctor.clinic_resources && Array.isArray(this.currentDoctor.clinic_resources)){
              // Load clinic resources for resource_based clinics
              this.clinic_resources = this.currentDoctor.clinic_resources.map(
                (data) => ({ id: data._id, title: data.name })
              );
              this.setupCalendarAfterResourcesLoaded(currentDoctor);
            } else if(this.currentDoctor.account_type !== 'resource_based') {
              // Load doctor resources for doctors_based clinics from API
              this.doctorResourceService.getDoctorResources().pipe(takeUntil(this.destroy$)).subscribe(
                (doctor_resources: DoctorResource[]) => {
                  // Map doctor resources to calendar resources format
                  this.clinic_resources = doctor_resources.map(
                    (data) => ({
                      id: data._id,
                      title: data.doctor?.full_name || data.name || data.description || 'Doctor'
                    })
                  );
                  // Update currentDoctor with loaded doctor_resources
                  this.currentDoctor.doctor_resources = doctor_resources;
                  this.setupCalendarAfterResourcesLoaded(currentDoctor);
                },
                (error) => {
                  console.error('Error loading doctor resources:', error);
                  // Fallback: no resources found
                  this.clinic_resources = [{ id: this.currentDoctor.id, title: (this.currentDoctor.first_name + " " + this.currentDoctor.last_name) }]
                  this.setupCalendarAfterResourcesLoaded(currentDoctor);
                }
              );
            } else {
              // Fallback: no resources found
              this.clinic_resources = [{ id: this.currentDoctor.id, title: (this.currentDoctor.first_name + " " + this.currentDoctor.last_name) }]
              this.setupCalendarAfterResourcesLoaded(currentDoctor);
            }
          } else {
            // Not a clinic, use doctor's own calendar
            this.clinic_resources = [{ id: this.currentDoctor.id, title: (this.currentDoctor.first_name + " " + this.currentDoctor.last_name) }]
            this.setupCalendarAfterResourcesLoaded(currentDoctor);
          }
        }
      }
    });
    this.getToConfirmBookingSLots();
    this.getDoctorBookingsTypes();

    // App-wide 30s heartbeat (started in AppComponent) + manual triggers
    // (e.g. booking dialog) both land here while the calendar is open.
    // refreshCalendar() refetches events AND the to-confirm list.
    this.calendarRefreshService.refresh$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.refreshCalendar();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    // ngOnInit shows the global spinner; it is only hidden in setupCalendarConfig.
    // If we are destroyed before that runs (doctor/translate not yet resolved),
    // hide it so it doesn't stay stuck over the next page.
    this.globalService.hideSpinner();
  }

  setupCalendarAfterResourcesLoaded(doctor: Doctor) {

    // Only set time values on initial setup, not on updates
    if (!this.calendarInitialized) {
      this.slotMinTime = doctor.opening_hour;
      this.slotMaxTime = doctor.closing_hour;
      this.calendarInitialized = true;
    }

    this.clinic = doctor.clinic;

    moment.tz.setDefault(doctor.time_zone); // force the correct doctor's timezone
    // takeUntil: this resolves async; landing after destroy would call
    // hideSpinner() and could dismiss the next page's spinner.
    this.translate.use(doctor.locale).pipe(takeUntil(this.destroy$)).subscribe(() => {
      // Localize the PrimeNG date picker (month/day names, week start).
      this.primeng.setTranslation(getPrimeNgDateLocale(doctor.locale));
      this.setupCalendarConfig(doctor);
    });
  }

  private fetchEvents(dateInfo) {
    const filters = `state=confirmed_doctor,confirmed_assistant,awaiting_payment&start=${dateInfo.start?.toISOString()}&end=${dateInfo.end?.toISOString()}&timeZone=${dateInfo.timeZone}`;
    return this.bookingSlotsService.get(filters)
      .toPromise()
      .then((response: any) => {
        if (Array.isArray(response)) {
          return response;
        }
        if (response && Array.isArray(response.data)) {
          return response.data;
        }
        if (response && Array.isArray(response.events)) {
          return response.events;
        }
        return [];
      })
      .catch((error: any) => {
        // We need to discover what is going on here, we need to find out what is causing the error and why the error is not being serialized correctly.

        let errorJson: string;
        try {
          errorJson = JSON.stringify(error, null, 2);
        } catch (e) {
          // If JSON.stringify fails (circular refs, etc.), manually extract what we can
          const errorInfo: any = {
            error_type: typeof error,
            error_constructor: error?.constructor?.name || 'unknown',
            error_string: String(error),
            has_message: !!error?.message,
            has_stack: !!error?.stack,
            has_name: !!error?.name,
          };
          
          // Try to extract common properties safely
          if (error && typeof error === 'object') {
            try {
              if (error.message) errorInfo.message = String(error.message);
              if (error.name) errorInfo.name = String(error.name);
              if (error.status) errorInfo.status = String(error.status);
              if (error.statusText) errorInfo.statusText = String(error.statusText);
              if (error.url) errorInfo.url = String(error.url);
              if (error.code) errorInfo.code = String(error.code);
            } catch (extractError) {
              errorInfo.extraction_failed = String(extractError);
            }
          }
          
          errorJson = JSON.stringify(errorInfo, null, 2);
        }
        
        Sentry.withScope((scope) => {
          scope.setExtra('error_data', errorJson);
          scope.setTag('error_source', 'fullcalendar_fetch_events');
          Sentry.captureException(error instanceof Error ? error : new Error('FullCalendar fetch events error'));
        });
        
        return [];
      });
  }

  clinicHasOneResource()
  {
    if (!this.clinic || !this.currentDoctor) return false;
    
    if (this.currentDoctor.account_type === 'resource_based') {
      return this.currentDoctor?.clinic_resources?.length === 1;
    } else {
      return this.currentDoctor?.doctor_resources?.length === 1;
    }
  }

  get headerToolbarView()
  {
    if(this.clinicHasOneResource())
    {
      return "dayGridMonth,resourceTimeGridWeek,resourceTimeGridDay,list";
    }
    else if (this.clinic)
    {
      return "resourceTimeGridDay"
    }
    else
    {
      // Add 3-day view option for mobile devices
      if (this.isMobile) {
        return 'dayGridMonth,timeGridWeek,timeGridThreeDay,timeGridDay,list';
      } else {
        return 'dayGridMonth,timeGridWeek,timeGridDay,list';
      }
    }
  }

  setupCalendarConfig(doctor: Doctor): void {
    this.globalService.hideSpinner();
    const todayDate = moment().startOf("day");
    const TODAY = todayDate.format("YYYY-MM-DD");
    const averageSlotDuration = doctor.average_time_interval;

    const self = this;
    const locale = this.currentDoctor.locale;
    
    let initialView;
    if (!this.clinic) 
    {
      initialView = this.initialView;
    } 
    else if (this.clinicHasOneResource())
    {
      initialView = "resourceTimeGridWeek";
    } 
    else
    {
      initialView = "resourceTimeGridDay";
    }
    
    this.calendarConfig = {
      schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
      plugins: [
        dayGridPlugin,
        listPlugin,
        interactionPlugin,
        timeGridPlugin,
        momentPlugin,
        momentTimezonePlugin,
        resourceTimeGridPlugin,
      ],
      themeSystem: 'bootstrap',
      titleFormat: function (date) {
        const startDate = moment(date.start).locale(locale);
        const endDate = moment(date.end).locale(locale);
    
        const formattedStartDate = startDate.format('D');
        const formattedEndDate = endDate.format('D');
        const monthYear = startDate.format('MMMM YYYY');

        const isSameMonthYear = startDate.isSame(endDate, 'month') && startDate.isSame(endDate, 'year');

        let title = '';

        if (formattedStartDate == formattedEndDate) {
          title += formattedStartDate;
        } else {
          title += `${formattedStartDate} – ${formattedEndDate}`;
        }
        title += isSameMonthYear ? ` ${monthYear}` : ` ${startDate.format('MMMM')} – ${endDate.format('MMMM')} ${endDate.format('YYYY')}`;

        return title;
      },
      headerToolbar: {
        left: "prev,next,today",
        center: "title",
        right: this.headerToolbarView,
      },
      height: 800,
      contentHeight: 780,
      longPressDelay: this.PressDelay,
      aspectRatio: 3,
      nowIndicator: true,
      views: {
        timeGridThreeDay: {
          type: 'timeGrid',
          duration: { days: 3 },
          buttonText: this.translate.instant('connect.calendar.three_days_view')
        }
      },
      initialView: initialView,
      initialDate: TODAY,
      allDaySlot: true,
      slotMinTime: `${this.slotMinTime}:00:00`,
      slotMaxTime: `${this.slotMaxTime}:00:00`,
      timeZone: doctor.time_zone,
      slotDuration: `00:${averageSlotDuration}:00`,
      editable: false,
      dayMaxEventRows: true,
      navLinks: true,
      selectable: true,
      locales: [frLocale],
      locale: doctor.locale,
      eventTimeFormat: "H:mm",
      events: this.fetchEvents.bind(this),
      displayEventEnd: false,
      eventSourceFailure: (obj) => {
        // TODO show an error message
      },
      viewDidMount: () => {
        // Replay any refresh that arrived before the view was ready.
        if (this.pendingRefetch) {
          this.pendingRefetch = false;
          this.requestEventsRefetch();
        }
      },
      loading: (isLoading: boolean) => {
        Promise.resolve().then(() => { this.calendarLoading = isLoading; this.cdr.detectChanges(); });
      },
      // Transform bookings attributes to proper fullcalendar objects
      eventDataTransform: (eventData: any) => {
        let x: EventInput = this.transformBookingSlotToEvent(eventData)
        return x;
      },
      dayCellDidMount : (event) => {
        if ( ["timeGridWeek", "resourceTimeGridWeek", "timeGridDay", "resourceTimeGridDay"].includes(event.view.type) &&
          (event.isFuture || event.isToday))
        {
          let availableDays;
          if (this.currentDoctor?.clinic) {
            const resourceAvailability = this.available_days_for_clinic_resources?.find(
              resource => resource.id === event.resource?.id
            );
            availableDays = resourceAvailability?.available_days;
          } else {
            availableDays = this.currentDoctor?.available_days;
          }

          if (availableDays?.length > 0) {
            const dayIndex = (event.dow + 6) % 7;
            const available = availableDays[dayIndex]?.available;

            if(this.findParentByClass(event.el, "fc-daygrid-body") && available)
            {
              event.el.className += " cancel_day"
              event.el.innerHTML = '<span class="cancel-day-btn fa fa-times-circle"></span>';
            }
            else
            {
              if(!available)
              {
                event.el.classList.add('unavailable-day');
                if (this.findParentByClass(event.el, "fc-daygrid-body"))
                {
                  event.el.innerHTML = '<span title="' + this.translate.instant("connect.globals.no_availabilities_for_this_day")
                  + '" class="cancel-day-btn fa fa-question-circle"></span>';
                }
              }
            }
          }
        }
      },
      eventDidMount : (event) => {
        const titleEl = event.el.querySelector('.fc-event-title');
        const mainEl = event.el.querySelector('.fc-event-main') || event.el;


        // Create or reuse a right-aligned icon container
        let icons = mainEl.querySelector('.fc-event-icons') as HTMLElement;
        if (!icons) {
          icons = document.createElement('span');
          icons.className = 'fc-event-icons';
          mainEl.appendChild(icons);
        } else {
          icons.innerHTML = '';
        }

        // Add icons based on event props
        const isVideo = event.event.extendedProps.type === BookingType.VIDEO;
        const isHome = event.event.extendedProps.type === BookingType.HOME;
        const awaitingPayment = event.event.extendedProps.state === StateType.AWAITING_PAYMENT;

        if (isVideo && awaitingPayment) {
          const warn = document.createElement('i');
          warn.className = 'fa fa-exclamation-circle slot-event-background';
          icons.appendChild(warn);
        }
        if (isVideo) {
          const vid = document.createElement('i');
          vid.className = 'fa fa-video slot-event-background';
          icons.appendChild(vid);
        }
        if (isHome) {
          const home = document.createElement('i');
          home.className = 'fa fa-home slot-event-background';
          icons.appendChild(home);
        }

        // Append the partner badge without replacing the title text node.
        if (titleEl && event.event.extendedProps && event.event.extendedProps.partner && !titleEl.querySelector('.partner_slot')) {
          const badge = document.createElement('span');
          badge.className = 'partner_slot';
          badge.textContent = event.event.extendedProps.partner;
          titleEl.appendChild(badge);
        }

        if (event.event.extendedProps.patient_didnt_showup) event.el.classList.add('didntshowup');
      },
      select: (arg) => {
        const currentView = arg.view.type;
        if (currentView === 'dayGridMonth') {
          arg.allDay = false; // Force allDay to false in month view to show the appointement 
        }
        if (arg.allDay) {
          const isValidDate = arg.start.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
          isValidDate ? this.toggleDayAvailability(arg.startStr, this.getResourceId(arg)) : this.snackbar.open(this.translate.instant("connect.calendar.invalid_slot"));
        }
        else 
        {
          //prevent default for intentional selections, allow scrolling
          if (arg.jsEvent) {
            if (!this.isMobile) {
              // Desktop: always prevent default for clicks
              arg.jsEvent.preventDefault();
            } else {
              // Mobile: only prevent default for intentional taps, rely on FullCalendar's longPressDelay
              if (arg.jsEvent.type === 'click' || 
                  (arg.jsEvent.type === 'touchend' && this.PressDelay > 0)) {
                arg.jsEvent.preventDefault();
              }
              // For quick taps on mobile when longPressDelay is 0, also prevent default
              if (arg.jsEvent.type === 'touchend' && this.PressDelay === 0) {
                arg.jsEvent.preventDefault();
              }
              // Let scroll gestures pass through naturally
            }
          }

          const time_interval = moment.utc(arg.end).diff(moment.utc(arg.start), 'minutes');
          let selection_type = "multiple_slot";
          if (arg.start < new Date()) {
            if (this.fullCalendarApi) {
              this.fullCalendarApi.unselect();
            }
          } else {
            if (doctor.average_time_interval == time_interval) {
              selection_type = "single_slot";
            }
            const resourceId = this.getResourceId(arg);

            setTimeout(() => {
              const bookingSlot = this.transformEventToBookingSlot(arg);
              const calculatedEnd = moment.utc(bookingSlot.starts_at).add(time_interval, 'minutes').toDate();
              if (moment.utc(bookingSlot.ends_at).diff(moment.utc(bookingSlot.starts_at), 'minutes') !== time_interval) {
                bookingSlot.ends_at = calculatedEnd;
              }
              this.openBookingModal({
                bookingSlot: bookingSlot,
                available_days_for_clinic_resources: this.available_days_for_clinic_resources,
                selection_type: selection_type,
                resourceId: resourceId
              });
            }, 100);
          }
        }
      },
      resources: this.clinic_resources || [],
      eventDrop: (arg) => {
        // if the new start time is in the past
        if (arg.event.start < new Date()) {
          arg.revert();
        } else {
          this.updateBookingSlotFromCalendar(arg);
        }
      },
      eventResize: (arg) => {
        // if the new start time is in the past
        if (arg.event.start < new Date()) {
          arg.revert();
        } else {
          this.updateBookingSlotFromCalendar(arg);
        }
      },
      eventClick: (arg) => {
        this.openBookingModal({
          bookingSlot: {...this.transformEventToBookingSlot(arg.event), resourceId: arg.event._def.resourceIds[0]},
          available_days_for_clinic_resources: this.available_days_for_clinic_resources
        });
      },
    };
  }

  getCurrentResource(event)
  {
    return this.currentDoctor.clinic ? this.currentDoctor.available_days_for_clinic_resources?.find(resource => resource.id == event.resource._resource.id ) : this.currentDoctor
  }

  getResourceId(arg:any)
  {
    if(this.clinic)
    {
      if (this.currentDoctor.account_type === 'resource_based') {
        return this.clinicHasOneResource() && this.currentDoctor?.clinic_resources?.[0] 
          ? this.currentDoctor.clinic_resources[0]._id 
          : arg?.resource?._resource?.id ?? null;
      } else {
        return this.clinicHasOneResource() && this.currentDoctor?.doctor_resources?.[0] 
          ? this.currentDoctor.doctor_resources[0]._id 
          : arg?.resource?._resource?.id ?? null;
      }
    }
    else
    {
      return null
    }
  }

  onDepartementChnage(event) {
    if (Array.isArray(this.clinic_resources)) {
      this.clinic_resources = this.clinic_resources.filter(
        (data) => data.doctor_speciality_id === event.target.value
      );
    }
  }

  findParentByClass(el, className)
  {
    for (let i = 0; i < 10; i++) {
      el = el.parentNode;
      if (el.classList.contains(className)) {
        return true;
      }
    }
  }

  getToConfirmBookingSLots(page: number = 1) {
    if (this.loadingPageToConfirm) return;

    this.loadingPageToConfirm = true;

    this.bookingSlotsService.toConfirm(page).subscribe({
      next: (response: any) => {
        // Ensure response exists and data is an array
        this.toConfirmBookingSlots = (response && Array.isArray(response.data)) ? response.data : [];
        this.currentPageToConfirm = response?.current_page || 1;
        this.totalPagesToConfirm = response?.total_pages || 1;
        this.totalCountToConfirm = response?.total_count || 0;
        this.loadingPageToConfirm = false;
      },
      error: (error) => {
        this.errorHelper.logErrorAndExtractMessage(error, Sentry);
        this.loadingPageToConfirm = false;
        // Set empty array on error to prevent iteration errors
        this.toConfirmBookingSlots = [];
      }
    });
  }


  onSelect(event, _moment = moment) {
    this.selectedDate = event;
    if (this.fullcalendar) {
      this.fullcalendar.getApi().gotoDate(moment(event).format(moment.HTML5_FMT.DATE));
    }
  }

  cancelBookingSlot(bookingSlot) {
    const text = this.bookingHelper.getCancelMessage(bookingSlot);
    this.alertService.fire({
      heightAuto: false,
      focusConfirm: false,
      title: this.translate.instant("connect.globals.confirmation_box_title"),
      text: text,
      icon: this.translate.instant("connect.globals.confirmation_box_type"),
      destructive: true,
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#808285",
      confirmButtonText: this.translate.instant(
        "connect.globals.cancel_booking"
      ),
      cancelButtonText: this.translate.instant("connect.globals.cancel")
    }).then((result) => {
      if (result.value) {
        return this.bookingSlotsService.cancel(bookingSlot.id).subscribe(
          (data) => {
            this.getToConfirmBookingSLots();
            this.refreshCalendar();
            this.alertService.fire({
              heightAuto: false,
              focusConfirm: false,
              text: this.translate.instant("connect.calendar.booking_cancelled"),
              icon: "success"
            });
            this.snackbar.open(
              this.translate.instant("connect.calendar.booking_cancelled")
            );
          },
          (error) => this.errorHandler.handleError("Error occurred")
        );
      }
    });
  }

  toggleDayAvailability(current_day: string, resourceId: string) {
    // Block/unblock a day is a calendar-only refresh. Use the calendar-scoped
    // loader (the "Chargement des rendez-vous..." badge), NOT the global page
    // spinner — the rest of the app must stay interactive and un-blurred.
    this.setCalendarLoading(true);
    this.bookingSlotsService.toggleDayAvailability(current_day,resourceId).subscribe(
      (data: any) => {
        if (data)
          this.snackbar.open(this.errorHelper.extractSuccessMessage(data.message, 'connect.calendar'));
        // refreshCalendar() refetches events; FullCalendar's `loading` hook keeps
        // the badge visible until the refetch completes, then clears it — so we
        // don't clear it manually here and risk hiding it mid-refetch.
        this.refreshCalendar();
      },
      (error) => {
        this.setCalendarLoading(false);
        this.snackbar.open(this.errorHelper.extractErrorMessage(error, 'connect.calendar'));
      }
    );
  }

  // Toggle the calendar-scoped loading badge. Deferred + explicit change
  // detection mirrors the FullCalendar `loading` hook, since this can be called
  // from a FullCalendar callback that runs outside Angular's zone.
  private setCalendarLoading(isLoading: boolean) {
    Promise.resolve().then(() => {
      this.calendarLoading = isLoading;
      this.cdr.detectChanges();
    });
  }

  confirmBookingSlot(bookingSlot) {
    const text = this.bookingHelper.getCancelMessage(bookingSlot);
    
    if (this.doctorService.current.clinic && !this.clinicHasOneResource() && (bookingSlot.resourceId == null || bookingSlot.resourceId == "")) {
      this.alertService.fire({
        heightAuto: false,
        focusConfirm: false,
        text: this.translate.instant("connect.globals.edit_appointement_add_doctor"),
        icon: "info"
      });
      return;
    }
  
    // Determine which resource ID to use based on account_type
    let resourceId = null;
    let updatePayload: any = { ...bookingSlot };
    
    if (this.clinicHasOneResource()) {
      if (this.currentDoctor.account_type === 'resource_based' && this.currentDoctor?.clinic_resources?.[0]) {
        updatePayload.clinic_resource_id = this.currentDoctor.clinic_resources[0]._id;
        resourceId = this.currentDoctor.clinic_resources[0]._id;
      } else if (this.currentDoctor.account_type !== 'resource_based' && this.currentDoctor?.doctor_resources?.[0]) {
        updatePayload.doctor_resource_id = this.currentDoctor.doctor_resources[0]._id;
        resourceId = this.currentDoctor.doctor_resources[0]._id;
      }
    }
    
    const updateObservable = resourceId ? 
      this.bookingSlotsService.update(updatePayload) : 
      of(null);
  
    updateObservable.subscribe({
      next: () => {
        this.alertService.fire({
          heightAuto: false,
          focusConfirm: false,
          title: this.translate.instant("connect.globals.confirmation_box_title"),
          text: text,
          icon: this.translate.instant("connect.globals.confirmation_box_type"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#808285",
          confirmButtonText: this.translate.instant("connect.globals.booking_confirm"),
          cancelButtonText: this.translate.instant("connect.globals.cancel")
        }).then((result) => {
          if (result?.value && bookingSlot?.id) {
            this.bookingSlotsService.confirm(bookingSlot.id).subscribe({
              next: () => {
                this.refreshCalendar();
                this.getToConfirmBookingSLots();
                this.alertService.fire({
                  heightAuto: false,
                  focusConfirm: false,
                  text: this.translate.instant('connect.calendar.booking_confirmed'),
                  icon: "success"
                });
                this.snackbar.open(this.translate.instant("connect.calendar.booking_confirmed"));
              },
              error: (error) => {
                this.errorHandler.handleError(this.translate.instant("connect.calendar.error_occurred"));
              }
            });
          }
        });
      },
      error: (error) => {
        this.errorHandler.handleError(this.translate.instant("connect.globals.error_occured_message"));
      }
    });
  }

  getDoctorBookingsTypes() {
    this.doctorService
      .getBookingsTypes()
      .subscribe((types: BookingSlotType[]) => (this.doctorBookingTypes = types));
  }

  navigateToLink(url: string) {
      this.router.navigate(["/" + url]);
  }

  changeSlotDuration(averageSlotDuration) {
    const newInterval = Number(averageSlotDuration);
    this.calendarConfig.slotDuration = "00:" + newInterval + ":00";

    if (this.currentDoctor) {
      this.currentDoctor.average_time_interval = newInterval;
      this.doctorService.updateCurrentDoctor(this.currentDoctor);
    }

    this.refreshCalendar();
  }

  onStartTimeChange(newTime: string) {
    this.minTime = Number(newTime);
  }

  onEndTimeChange(newTime: string) {
    this.maxTime = Number(newTime);
  }

  isClicked:boolean = false;
  saveAllSettings() {
    this.isClicked = true;

    const currentInterval = this.currentDoctor?.average_time_interval;
    if (currentInterval) {
      this.doctorService.updateTimeInterval(currentInterval).subscribe(
        (intervalData) => {
          const updatedDoctor = { ...this.currentDoctor, average_time_interval: currentInterval };
          this.doctorService.updateCurrentDoctor(updatedDoctor);
          this.isClicked = false;

        },
        (error) => {
          console.error('Failed to save interval:', error);
          this.isClicked = false;
        }
      );
    }

    this.calendarConfig.slotMinTime = `${this.slotMinTime}:00:00`;
    this.calendarConfig.slotMaxTime = `${this.slotMaxTime}:00:00`;

    this.doctorService.updateTimeSlots(this.slotMinTime, this.slotMaxTime).subscribe(
      (timeData) => {
        const updatedDoctor = {
          ...this.currentDoctor,
          opening_hour: this.slotMinTime,
          closing_hour: this.slotMaxTime
        };
        this.doctorService.updateCurrentDoctor(updatedDoctor);

        this.cdr.detectChanges();

        this.snackbar.open(
          this.translate.instant("connect.calendar.updated_settings")
        );

        this.refreshCalendar();
        if (this.fullCalendarApi) {
          this.fullCalendarApi.setOption('slotMinTime', `${this.slotMinTime}:00:00`);
          this.fullCalendarApi.setOption('slotMaxTime', `${this.slotMaxTime}:00:00`);
        }
        this.isClicked = false;
      },
      (error) => {
        this.errorHandler.handleError(
          this.translate.instant("connect.globals.error_occured_message")
        );
        this.isClicked = false;
      }
    );
  }


  public refreshCalendar() {
    this.getToConfirmBookingSLots();
    this.requestEventsRefetch();
  }

  private requestEventsRefetch() {
    const api = this.fullcalendar?.getApi();
    if (!api) {
      // The calendar isn't mounted yet (e.g. a realtime event arrived during
      // load). Replay the refetch once viewDidMount fires.
      this.pendingRefetch = true;
      return;
    }

    this.fullCalendarApi = api;
    // Run inside Angular's zone so FullCalendar's async fetch resolution and the
    // resulting re-render are flushed within change detection. Realtime events
    // arrive through an ActionCable callback that can be outside the zone, which
    // is why a successful refetch could update data without repainting until the
    // next interaction.
    this.zone.run(() => api.refetchEvents());
  }

  private transformBookingSlotToEvent(bookingSlot: BookingSlot): any {
    const video = bookingSlot.type === BookingType.VIDEO;
    const isBlocking = bookingSlot.slot_type === SlotType.BLOCKING;
    const title = !isBlocking
      ? bookingSlot.user_first_name + " " + bookingSlot.user_last_name
      : "";
    // Only future appointments are editable
    const isEditable = new Date(bookingSlot.starts_at) > new Date();

    // Simple color contrast detection
    let colorClass = '';
    if (bookingSlot.color) {
      const color = bookingSlot.color.toLowerCase();
      // Calculate brightness (0-255)
      const r = parseInt(color.substring(1, 3), 16);
      const g = parseInt(color.substring(3, 5), 16);
      const b = parseInt(color.substring(5, 7), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      
      colorClass = brightness > 155 ? 'light-color-event' : 'dark-color-event';
    }

    // Build classNames array and filter out empty strings to prevent FullCalendar iteration errors
    // Ensure it's always an array (never null/undefined) to prevent "not iterable" errors
    const classNames = [
      isBlocking ? "canceled_slot blocked_slot" : "", 
      video ? "video_slot" : "",
      colorClass
    ].filter(className => className && className.length > 0);

    // Determine resource ID for resource-timegrid view
    let resourceId = null;
    if (this.clinic && this.currentDoctor) {
      // Check if booking slot has a resource ID (prioritize explicit IDs)
      if (bookingSlot.clinic_resource_id) {
        resourceId = String(bookingSlot.clinic_resource_id);
      } else if (bookingSlot.doctor_resource_id) {
        resourceId = String(bookingSlot.doctor_resource_id);
      } else if (bookingSlot.resourceId) {
        resourceId = String(bookingSlot.resourceId);
      } else if (this.clinicHasOneResource()) {
        // If clinic has only one resource, use that resource ID
        if (this.currentDoctor.account_type === 'resource_based' && this.currentDoctor?.clinic_resources?.[0]) {
          resourceId = String(this.currentDoctor.clinic_resources[0]._id);
        } else if (this.currentDoctor.account_type !== 'resource_based' && this.currentDoctor?.doctor_resources?.[0]) {
          resourceId = String(this.currentDoctor.doctor_resources[0]._id);
        }
      }
    }

    const fcEvent : EventInput = {
      id: bookingSlot.id,
      title: title,
      start: bookingSlot.starts_at,
      end: bookingSlot.ends_at,
      classNames: classNames,
      editable: isEditable,
    };

    // Set resourceIds for resource-timegrid view (must match resource IDs in calendar)
    if (resourceId && this.clinic) {
      // Ensure the resourceId exists in the clinic_resources array
      const resourceExists = this.clinic_resources.some(r => String(r.id) === resourceId);
      if (resourceExists) {
        fcEvent.resourceIds = [resourceId];
      } else {
        // If resource not found, try to find it by matching the ID format
        console.warn('Resource ID not found in calendar resources:', resourceId, 'Available resources:', this.clinic_resources);
      }
    }

    if (isBlocking && bookingSlot.color) {
      fcEvent.backgroundColor = bookingSlot.color;
      fcEvent.borderColor = bookingSlot.color;
    }

    return Object.assign(fcEvent, bookingSlot);
  }

  private transformEventToBookingSlot(event): BookingSlot {
    const booking = Object.assign({}, event.extendedProps);
    return Object.assign(booking, {
      id: event.id,
      starts_at: event.start,
      ends_at: event.end,
    });
  }

  private updateBookingSlotFromCalendar(arg) {
    this.bookingSlotsService
      .update(this.transformEventToBookingSlot(arg.event))
      .subscribe(
        (success) => {
          // TODO All good, show a confirmation toaster
          this.refreshCalendar();
        },
        (error) => {
          arg.revert();
        }
      );
  }

  editBookingSlot(bookingSlot)
  {
    this.openBookingModal({...bookingSlot, available_days_for_clinic_resources: this.available_days_for_clinic_resources})
  }

  private openBookingModal(data = {}) {
    this.dialog.open(BookingDialogComponent, {
        ...BOOKING_DIALOG_CONFIG,
        data: data,
        disableClose: false,
      })
      .afterClosed()
      .subscribe(() => {
        this.refreshCalendar();
      });
  }

  private checkDevice() {
    //Check the device if Mobile then show the calendar by day, otherwise show it by week.
    // TODO use https://www.npmjs.com/package/ngx-device-detector
    if (window.innerWidth <= 1024) {
      this.isMobile = true;
      if (window.innerWidth <= 425) {
        // Very small devices get day view
        this.initialView = "timeGridDay";
        this.PressDelay = 300;
      } else {
        // Mobile and tablet devices get 3-day view (better for touch devices)
        this.initialView = "timeGridThreeDay";
        this.PressDelay = 300;
      }
    } else {
      this.isMobile = false;
      this.initialView = "timeGridWeek";
      this.PressDelay = 0;
    }
  }
  onResize() {
    const previousView = this.initialView;
    this.checkDevice();
    
    // Update calendar view if it changed due to resize
    if (this.fullcalendar && this.fullcalendar.getApi() && previousView !== this.initialView) {
      const calendarApi = this.fullcalendar.getApi();
      
      // Update header toolbar to show appropriate view options
      calendarApi.setOption('headerToolbar', {
        left: "prev,next,today",
        center: "title",
        right: this.headerToolbarView,
      });
      
      // Switch to the appropriate view for the new screen size
      try {
        calendarApi.changeView(this.initialView);
      } catch (error) {
        console.warn('Failed to change view to:', this.initialView, error);
        // Fallback to a safe view
        calendarApi.changeView('timeGridDay');
      }
    }
  }

}
